import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root',
})
export class EnvironmentLoaderService {
  private http = inject(HttpClient);

  async getEnvData() {
    let envUrl: string = '../../../assets/environments/';
    if (environment.production === true) {
      envUrl += 'environment.json';
    } else {
      envUrl += 'environment-dev.json';
    }
    const envData = await this.http.get<any>(envUrl).toPromise();
    return this.normalizeEnvData(envData);
  }

  private normalizeEnvData(envData: any) {
    if (!envData || typeof envData !== 'object') {
      return envData;
    }

    const normalizedEnv = { ...envData };
    const hasTemplatePlaceholder = (value: any) => typeof value === 'string' && value.includes('${');

    const hostFromFile = normalizedEnv['TELEMETRY_SERVICE_HOST'];
    const endpointFromFile = normalizedEnv['TELEMETRY_SERVICE_ENDPOINT'];

    if (hasTemplatePlaceholder(hostFromFile) || hasTemplatePlaceholder(endpointFromFile)) {
      const telemetryFallback = this.getTelemetryFallbackFromWindowEnv();
      normalizedEnv['TELEMETRY_SERVICE_HOST'] = telemetryFallback.host;
      normalizedEnv['TELEMETRY_SERVICE_ENDPOINT'] = telemetryFallback.endpoint;
    }

    return normalizedEnv;
  }

  private getTelemetryFallbackFromWindowEnv() {
    const fallback = {
      host: '',
      endpoint: '/v1/telemetry',
    };

    const browserWindow: any = window;
    const telemetryUrl = browserWindow?.__env?.telemetryUrl;
    if (typeof telemetryUrl !== 'string' || !telemetryUrl.trim()) {
      return fallback;
    }

    const normalizedTelemetryUrl = telemetryUrl.trim().replace(/\/+$/, '');
    const endpointSuffix = '/v1/telemetry';
    if (normalizedTelemetryUrl.endsWith(endpointSuffix)) {
      return {
        host: normalizedTelemetryUrl.slice(0, -endpointSuffix.length),
        endpoint: endpointSuffix,
      };
    }

    return {
      host: normalizedTelemetryUrl,
      endpoint: fallback.endpoint,
    };
  }
}
